import { render, staticRenderFns } from "./LiquidationSubmissionNew.vue?vue&type=template&id=2fc3af12&scoped=true&lang=pug"
import script from "./LiquidationSubmissionNew.vue?vue&type=script&lang=js"
export * from "./LiquidationSubmissionNew.vue?vue&type=script&lang=js"
import style0 from "./LiquidationSubmissionNew.vue?vue&type=style&index=0&id=2fc3af12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3af12",
  null
  
)

export default component.exports